import React from 'react';
import styles from './Table.module.scss';

const Table = ({ children, ...props }) => {
  return (
    <table className={styles.Table} {...props}>
      {children}
    </table>
  );
};

export default Table;
